import type { TimelineItem } from "@/mocks/entries";

export default function EntryTimeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="relative border-l border-background-300 pl-6 md:pl-8">
      {items.map((item) => (
        <li key={`${item.date}-${item.title}`} className="relative pb-8 last:pb-0">
          <span className="absolute -left-[31px] top-1 flex h-3 w-3 items-center justify-center rounded-full bg-accent-500 md:-left-[39px]" />
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <time className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">
              {item.date}
            </time>
            <h4 className="font-heading text-base font-bold text-foreground-950">{item.title}</h4>
          </div>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
        </li>
      ))}
    </ol>
  );
}